import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock, Pill, FileText } from "lucide-react";

interface MedicationDetailsProps {
  medication: {
    id: string;
    name: string;
    dosage: string;
    frequency: string;
    start_date: string;
    end_date: string | null;
    expiry_date: string | null;
    notes: string | null;
    active: boolean;
  } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MedicationDetails = ({ medication, open, onOpenChange }: MedicationDetailsProps) => {
  if (!medication) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">{medication.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <Badge variant={medication.active ? "default" : "secondary"}>
              {medication.active ? "Actif" : "Inactif"}
            </Badge>
            {medication.expiry_date && (
              <Badge variant="outline" className="ml-2">
                Expire le {new Date(medication.expiry_date).toLocaleDateString()}
              </Badge>
            )}
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Pill className="h-5 w-5 text-primary" />
              <div>
                <p className="font-medium">Dosage</p>
                <p className="text-sm text-muted-foreground">{medication.dosage}</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <Clock className="h-5 w-5 text-primary" />
              <div>
                <p className="font-medium">Fréquence</p>
                <p className="text-sm text-muted-foreground">{medication.frequency}</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <Calendar className="h-5 w-5 text-primary" />
              <div>
                <p className="font-medium">Période</p>
                <p className="text-sm text-muted-foreground">
                  Du {new Date(medication.start_date).toLocaleDateString()}
                  {medication.end_date && ` au ${new Date(medication.end_date).toLocaleDateString()}`}
                </p>
              </div>
            </div>

            {medication.notes && (
              <div className="flex items-start gap-3">
                <FileText className="h-5 w-5 text-primary" />
                <div>
                  <p className="font-medium">Notes</p>
                  <p className="text-sm text-muted-foreground whitespace-pre-wrap">{medication.notes}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};